import {
    getAllRoleAssignments,
    type RoleAssignmentPermissionsView,
    type UserProfileDetailedPublicResponse,
} from '@pillar-portal/api-types';

function appendSearchToken(tokens: string[], value: string | null | undefined): void {
    const trimmedValue: string = value?.trim() ?? '';
    if (trimmedValue.length > 0) {
        tokens.push(trimmedValue);
    }
}

export function buildUserProfileSearchFilterText(user: UserProfileDetailedPublicResponse): string {
    const tokens: string[] = [];
    appendSearchToken(tokens, user.primary_email);
    appendSearchToken(tokens, user.first_name);
    appendSearchToken(tokens, user.last_name);
    appendSearchToken(tokens, user.user_uuid);

    for (const roleAssignment of getAllRoleAssignments(user)) {
        const assignment: RoleAssignmentPermissionsView = roleAssignment;
        appendSearchToken(tokens, assignment.role);
        appendSearchToken(tokens, assignment.organization_name);
        appendSearchToken(tokens, assignment.organization_uuid);
        appendSearchToken(tokens, assignment.role_assignment_uuid);
        appendSearchToken(tokens, assignment.permissions_bundle.name);
    }

    return tokens.join(' ').toLowerCase();
}
